 // Base classes for all buttons
 export const baseClasses =
 "inline-flex items-center justify-center font-medium transition-colors focus:outline-none cursor-pointer rounded-md";


// Variant-specific classes - removed focus:ring styles
export const variantClasses = {
 primary: "bg-primary-blue text-white hover:bg-blue-700 rounded-md",
 secondary: "bg-gray-600 text-white hover:bg-gray-700 rounded-md",
 outline: "border border-utilityGray-200  text-utilityGray-700 hover:bg-gray-50 rounded-md",
 ghost: "text-gray-700 rounded-md",
 danger: "bg-error-600 text-white hover:bg-error-700 rounded-md",
 cancel: "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 rounded-md",
 purple: "bg-primary text-white hover:bg-primary rounded-md",
 white: "bg-white text-[#414651] border border-[#D5D7DA] hover:bg-gray-50 rounded-md",
 cart: "bg-white border border-[#D5D7DA]  text-[#7144FF] rounded-md hover:text-white hover:bg-[#7144FF] ",
 variantSelected: "!px-3 h-10 border border-[#6938EF] bg-[#F5F3FF] text-[#7A5AF8] shadow-[inset_0px_0px_0px_1px_rgba(10,13,18,0.18),inset_0px_-2px_0px_rgba(10,13,18,0.05)] drop-shadow-[0px_1px_2px_rgba(10,13,18,0.05)] rounded-lg",
 variantDefault: "!px-3 h-10 border border-[#D5D7DA] font-bold bg-white text-[#414651] shadow-[inset_0px_0px_0px_1px_rgba(10,13,18,0.18),inset_0px_-2px_0px_rgba(10,13,18,0.05)] drop-shadow-[0px_1px_2px_rgba(10,13,18,0.05)] rounded-lg",
};

// Size classes
export const sizeClasses = {
 sm: "px-3 py-1.5 text-sm",
 md: "px-4 py-2 text-sm",
 lg: "px-6 py-3 text-base",
};


export type ButtonVariant = 
  | "primary"
  | "secondary"
  | "outline"
  | "ghost"
  | "danger"
  | "cancel"
  | "purple"
  | "white"
  | "cart"
  | "variantSelected"
  | "variantDefault";

export type ButtonSize = "sm" | "md" | "lg";
export type ButtonRounded = "sm" | "md" | "lg" | "xl" | "2xl" | "full";